document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-watch').forEach(function (section) {
    var track = section.querySelector('[data-watch-track]');
    var prevBtn = section.querySelector('[data-watch-prev]');
    var nextBtn = section.querySelector('[data-watch-next]');
    var cards = section.querySelectorAll('.custom-watch__card');

    // --- Mute / unmute, only one video's audio on at a time ---
    cards.forEach(function (card) {
      var video = card.querySelector('.custom-watch__video');
      var muteBtn = card.querySelector('[data-watch-mute]');
      var videoWrap = card.querySelector('.custom-watch__video-wrap');

      // Click anywhere on the video (except the mute button or the arrow link)
      // navigates to the linked product.
      if (videoWrap) {
        var linkUrl = videoWrap.getAttribute('data-watch-link');
        if (linkUrl) {
          videoWrap.addEventListener('click', function (e) {
            if (e.target.closest('[data-watch-mute]')) return;
            if (e.target.closest('.custom-watch__arrow')) return;
            window.location.href = linkUrl;
          });
        }
      }

      if (!video || !muteBtn) return;

      var iconMuted = muteBtn.querySelector('.icon-muted');
      var iconUnmuted = muteBtn.querySelector('.icon-unmuted');

      muteBtn.addEventListener('click', function () {
        var willUnmute = video.muted;

        if (willUnmute) {
          // Mute every other video in this carousel first
          cards.forEach(function (otherCard) {
            if (otherCard === card) return;
            var otherVideo = otherCard.querySelector('.custom-watch__video');
            var otherBtn = otherCard.querySelector('[data-watch-mute]');
            if (otherVideo) otherVideo.muted = true;
            if (otherBtn) {
              otherBtn.querySelector('.icon-muted').style.display = '';
              otherBtn.querySelector('.icon-unmuted').style.display = 'none';
            }
          });
        }

        video.muted = !willUnmute;
        iconMuted.style.display = video.muted ? '' : 'none';
        iconUnmuted.style.display = video.muted ? 'none' : '';
      });
    });

    // --- Pause offscreen videos, resume onscreen ones (perf) ---
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target.querySelector('.custom-watch__video');
          if (!video) return;
          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.4 });

      cards.forEach(function (card) {
        observer.observe(card);
      });
    }

    // --- Nav arrows ---
    if (!track || !prevBtn || !nextBtn) return;

    function scrollAmount() {
      var firstCard = track.firstElementChild;
      if (!firstCard) return 280;
      var style = window.getComputedStyle(track);
      var gap = parseInt(style.columnGap || style.gap || 20, 10);
      return firstCard.getBoundingClientRect().width + gap;
    }

    function updateNavButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateNavButtons);
    window.addEventListener('resize', updateNavButtons);
    updateNavButtons();
  });
});